// extracted by mini-css-extract-plugin
export var addButton = "_bc-0";
export var border = "_bc-8";
export var check = "_bc-h";
export var danger = "_bc-6";
export var dropdownContainer = "_bc-1";
export var editModalBody = "_bc-j";
export var footerContainer = "_bc-i";
export var fullWidth = "_bc-a";
export var hide = "_bc-9";
export var icon = "_bc-3";
export var input = "_bc-7";
export var inputFlex = "_bc-b";
export var inputWrapper = "_bc-c";
export var manualFocus = "_bc-5";
export var optionButton = "_bc-4";
export var pillWrapper = "_bc-e";
export var pointer = "_bc-2";
export var showOverflow = "_bc-f";
export var tagsFlex = "_bc-d";
export var xButton = "_bc-g";